import { render, staticRenderFns } from "./IkoneDivider.vue?vue&type=template&id=00f30c13&scoped=true"
import script from "./IkoneDivider.vue?vue&type=script&lang=ts"
export * from "./IkoneDivider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f30c13",
  null
  
)

export default component.exports